import React from 'react';
import { landingStyles } from '../../styles/landing';
import {CardActionArea, Grid, CardMedia, CardContent, Typography, Container, Card, Box, Paper, TextField, Button} from '@mui/material';
import {content} from "../../constants"
const Visit = () => {
    const classes = landingStyles()
  return (
    <section id ="visit">

    <Container sx={{ py: 8 }} >
         <Grid item sm={12} xs={12} md={12}> 
            <Typography >
            <Box fontFamily="CormorantBoldItalic" className={classes.heading} style={{marginTop:-70}}>Schedule A Visit</Box></Typography>
            </Grid>        
         {/* <CardActionArea component="a" href="#"> */}
         <Paper  sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, pl:{lg:15}, pr:{ lg:15} }} elevation={3} >
        <Grid container >
         <Grid item xs={12} md={6} lg={6} sm={12}>
            <Typography variant="subtitle1" color="text.secondary" style={{padding:50}}>
              {content.visitDetail}
            </Typography> 
            </Grid>
            <Grid item xs={12} md={6} lg={6} sm={12}>
            <img src ="assets/images/visit.jpg" className ={classes.visitImage}/> 
            </Grid>    
            </Grid> 
            <Grid container spacing={3} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, pl:{lg:15}, pr:{ lg:15} }}>
        <Grid item xs={12} >
          <TextField
            required
            id="Name"
            name="name"
            label="Full Name"
            fullWidth
            autoComplete="given-name"
            variant="standard"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            required
            id="Email"
            name="email"
            label="Email"
            fullWidth
            autoComplete="shipping address-line1"
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="phone no"
            name="phoneNo"
            label="Phone No"
            fullWidth
            autoComplete="shipping address-level2"
            variant="standard"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="address"
            name="address"
            label="Address"
            fullWidth
            autoComplete="shipping address-line2"
            variant="standard"
          />
        </Grid>
       
        <Grid item xs={12} >
          <TextField
            id="report"
            name="report"
            label="Number of trees for report"
            fullWidth
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} >
          <TextField
            required
            id="about"
            multiline
            rows={4}
            name="about_project"
            label="Tell me more about this project"
            fullWidth
            autoComplete="shipping postal-code"
            variant="outlined"
          />
        </Grid>     
        <Grid item xs={12} md={6} lg={6} sm={12}>
          <Button
            variant="contained"
            style={{backgroundColor:"rgb(115 74 153)"}}
          >
            Send
          </Button>
          </Grid>
        </Grid>  
        </Paper>  
          {/* <CardMedia
            component="img"
            sx={{ width: 560, display: { xs: 'none', sm: 'block' } }}
            image="assets/images/visit.jpg"
            alt="image"
          /> */}
      {/* </CardActionArea> */}
       
    </Container >
    </section>

  )
}

export default Visit